import { MACKINAC_XRPC_URL } from '@/constants/api'

const GET_DIVINE_VIDEO_NSID = 'app.mackinac.embed.getDivineVideo'

export interface DivineVideoMeta {
    hlsUrl?: string
    videoUrl: string
    thumbnailUrl?: string
    contentType?: string
    dimensions?: { width: number; height: number }
}

interface DivineVideoResponse extends DivineVideoMeta {
    error?: string
}

/**
 * Resolves a Divine.video Nostr event ID to playable video metadata.
 * The event is immutable so results are safe to cache indefinitely.
 * Throws if the event is not found (HTTP 200 with error field) or the request fails.
 */
export async function fetchDivineVideo(eventId: string): Promise<DivineVideoMeta> {
    const params = new URLSearchParams()
    params.set('eventId', eventId)
    const url = `${MACKINAC_XRPC_URL}/xrpc/${GET_DIVINE_VIDEO_NSID}?${params.toString()}`

    const response = await fetch(url)

    if (!response.ok) {
        throw new Error(`getDivineVideo failed: ${response.status}`)
    }

    const body = (await response.json()) as DivineVideoResponse

    if (body.error === 'NOT_FOUND' || !body.videoUrl) {
        throw new Error('NOT_FOUND')
    }

    return {
        videoUrl: body.videoUrl,
        hlsUrl: body.hlsUrl,
        thumbnailUrl: body.thumbnailUrl,
        contentType: body.contentType,
        dimensions: body.dimensions,
    }
}
